import { render, staticRenderFns } from "./UsuarioEditar.vue?vue&type=template&id=c520b98e&scoped=true&"
import script from "./UsuarioEditar.vue?vue&type=script&lang=js&"
export * from "./UsuarioEditar.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioEditar.vue?vue&type=style&index=0&id=c520b98e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c520b98e",
  null
  
)

export default component.exports